"use client";

import { openClosableSubscribeDialog } from "@/context/redux/reducers/dialog/subscribe-dialog-slice";
import { useAppDispatch } from "@/hooks/redux-hooks";
import { useLang } from "@/hooks/use-lang";

import LockIcon from "ui/icon/shared/LockIcon";

export const ServiceQuotaMask = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { t } = useLang();
  const dispatch = useAppDispatch();

  return (
    <div className="relative">
      {children}
      <div
        className="group absolute inset-0 cursor-pointer bg-white/75 backdrop-blur-sm"
        onClick={() => dispatch(openClosableSubscribeDialog())}
      >
        <div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-2 text-center text-zinc-500">
          <LockIcon className="group-hover:animate-shake" />
          <p className="text-sm font-bold">{t.analysis.serviceQuota.title}</p>
        </div>
      </div>
    </div>
  );
};
